export type WorkshopArticle = {
    slug: string;
    eyebrow: string;
    title: string;
    description: string;
    status: string;
    sortDate?: string;
    image?: string;
    /** Markdown file served from public/articles/. */
    contentPath: string;
    hideListMarkers?: boolean;
};

export const workshopArticles: WorkshopArticle[] = [
    {
        slug: "fiinta-constienta-parteneriate",
        eyebrow: "ADULȚI · RELAȚII · LUNAR",
        title: "Ființa umană conștientă în parteneriate",
        description: "Responsabilitate. Respect. Colaborare.",
        status: "18–19 decembrie 2026",
        sortDate: "2026-12-18",
        image: "/articles/article/fiinta-constienta-parteneriate/cover.png",
        contentPath: "/articles/article/fiinta-constienta-parteneriate/fiinta-constienta-in-parteneriate.md",
        hideListMarkers: true,
    },
    {
        slug: "parinte-copil-lunar",
        eyebrow: "FAMILII · LUNAR",
        title: "Program Lunar Părinte – Copil",
        description: "Un weekend pe lună pentru relația voastră.",
        status: "11–12 decembrie 2026",
        sortDate: "2026-12-11",
        image: "/articles/article/parinte-copil-lunar/cover.png",
        contentPath: "/articles/article/parinte-copil-lunar/program-lunar-parinte-copil.md",
        hideListMarkers: true,
    },
    {
        slug: "atelier-laura-eli-andrei",
        eyebrow: "ADULȚI · ATELIER INTENSIV",
        title: "Limbajul chipului · Laura Eli și Andrei",
        description: "Un atelier profund, rafinat și revelator, creat pentru cei care simt chemarea de a se cunoaște cu adevărat, dincolo de aparențe.",
        status: "1–8 august · sosire 31 iulie · plecare 9 august",
        image: "/articles/article/atelier-laura-eli-andrei/cover.png",
        contentPath: "/articles/article/atelier-laura-eli-andrei/limbajul-chipului-laura-eli-andrei.md",
    },
    {
        slug: "stiinta-constientului",
        eyebrow: "ADULȚI · ATELIER DE 7 ZILE",
        title: "Știința conștientului în corpul tău",
        description: "Metodele Viziopinante • Personocrația • Știința Vindecării Germanice",
        status: "31 octombrie – 7 noiembrie 2026",
        sortDate: "2026-10-31",
        image: "/articles/article/stiinta-constientului/cover.png",
        contentPath: "/articles/article/stiinta-constientului/stiinta-constientului-in-corpul-tau.md",
        hideListMarkers: true,
    },
    {
        slug: "clubul-noilor-amintiri",
        eyebrow: "COPII 5–18 ANI · TABERE DE VACANȚĂ",
        title: "Clubul noilor amintiri",
        description: "Program de vacanță pentru copii/adolescenți",
        status: "9 iunie – 10 septembrie 2026",
        sortDate: "2026-09-10",
        image: "/articles/article/clubul-noilor-amintiri/cover.png",
        contentPath: "/articles/article/clubul-noilor-amintiri/clubul-noilor-amintiri.md",
    },
    {
        slug: "spatiul-tau",
        eyebrow: "ADULȚI · WEEKENDURI",
        title: "Spațiul tău pentru conștientizări și revelații",
        description: "Timp doar pentru tine • Ghidaj pentru claritate • Pași spre schimbare",
        status: "În fiecare sfârșit de săptămână",
        image: "/articles/article/spatiul-tau/cover.png",
        contentPath: "/articles/article/spatiul-tau/spatiul-tau-pentru-constientizari.md",
        hideListMarkers: true,
    },
    {
        slug: "in-realitate-sau-iluzie",
        eyebrow: "ADULȚI · ATELIERE TEMATICE",
        title: "În realitate sau iluzie",
        description: "Iluzia care devenind realitate influențează psihicul și fizicul.",
        status: "Ateliere tematice cu Andrei",
        image: "/articles/article/in-realitate-sau-iluzie/cover.png",
        contentPath: "/articles/article/in-realitate-sau-iluzie/in-realitate-sau-iluzie.md",
    }
];

// Dated articles come first, newest listed occurrence first.
workshopArticles.sort((a, b) => (b.sortDate || "").localeCompare(a.sortDate || ""));
